export const POSTHOG_PROJECT_NAME = 'meetings';
export const POSTHOG_API_KEY = 'phc_WoURcD2xBiyUb3BuBg7GI0gI5mCfulqabf0pQqmEH4d';
export const POSTHOG_PROJECT_UUID = '92129bae-f3ed-4b28-b219-031c7f4c82dd';

export const POSTHOG_CATEGORIES = {
  MULTI_SERVICE_BOOKING: 'multi-service-booking',
};

export const POSTHOG_ACTIONS = {
  CHECKOUT: 'checkout',
};

export const POSTHOG_KEYS = {
  MULTI_SERVICE_BOOKING_CONFIRMED: 'bookme-multi-service-booking-confirmed',
};
